<template>
  <div
    v-show="showToolTip"
    :class="[
      wrapperClasses,
      'tw-transition-all tw-duration-200 tw-ease-out',
      showToolTip
        ? 'tw-pointer-events-auto tw-opacity-100'
        : 'tw-pointer-events-none tw-opacity-0',
      'tw-z-50 tw-w-max',
    ]"
  >
    <div
      :class="[
        'tw-relative tw-z-50 tw-flex tw-max-w-[470px] tw-flex-col tw-gap-2 tw-overflow-visible tw-rounded-lg tw-bg-[#3B4143] tw-text-white tw-shadow-[0_4px_24px_rgba(0,0,0,0.2)]',
        'tw-transition-opacity tw-duration-200 tw-ease-out',
        !customWidth ? defaultWidth : null,
      ]"
      :style="typeof customWidth === 'object' ? customWidth : null"
    >
      <div class="tw-flex tw-items-start tw-gap-2 tw-p-2">
        <!-- Content -->
        <div
          :class="['tw-flex-1 tw-w-max tw-text-[16px] tw-leading-[1.5]']"
        >
          <slot name="body"></slot>
        </div>
        <!-- Close button -->
        <button
          v-if="canCloseToolTip"
          type="button"
          class="tw-flex-shrink-0 tw-self-start tw-text-center tw-text-[16px] tw-leading-[150%] tw-text-white"
          aria-label="Close tooltip"
          @click.stop.prevent="$emit('close-tool-tip')"
        >
          ✕
        </button>
      </div>
      <!-- Tooltip Arrow -->
      <div :class="arrowClasses"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    showToolTip: { type: Boolean, default: false },
    canCloseToolTip: { type: Boolean, default: false },
    placement: {
      type: String,
      default: null,
      validator: (value) =>
        ['left', 'right', 'bottom', 'custom', null].includes(value),
    },
    customWidth: {
      type: [String, Object],
      default: null,
    },
    defaultWidth: {
      type: String,
      default: 'tw-w-max',
    },
    customWrapperClasses: {
      type: String,
      default: 'tw-left-[-54px]',
    },
    customArrowClasses: {
      type: String,
      default: '',
    },
  },
  emits: ['close-tool-tip'],
  computed: {
    wrapperClasses() {
      const base = 'tw-absolute tw-z-50';

      if (this.placement === 'right') {
        return [
          base,
          'tw-left-full tw-top-1/2 tw-ml-[10px] -tw-translate-y-1/2',
        ];
      }

      if (this.placement === 'left') {
        return [
          base,
          'tw-right-full tw-top-1/2 tw-mr-[10px] -tw-translate-y-1/2',
        ];
      }

      if (this.placement === 'bottom') {
        return [
          base,
          'tw-top-full tw-left-1/2 tw-mt-[10px] -tw-translate-x-1/2',
        ];
      }

      if (this.placement === 'custom') {
        return [base, 'tw-top-full tw-mt-[10px]', this.customWrapperClasses];
      }

      // Tooltip defaults to display at the top
      return [
        base,
        'tw-bottom-full tw-left-1/2 tw-mb-[12px] -tw-translate-x-1/2',
      ];
    },
    arrowClasses() {
      const base = 'tw-absolute tw-h-0 tw-w-0 tw-border-solid';

      if (this.placement === 'right') {
        return [
          base,
          'tw-left-[-8px] tw-top-1/2 -tw-translate-y-1/2',
          'tw-border-t-[8px] tw-border-b-[8px] tw-border-r-[8px]',
          'tw-border-t-transparent tw-border-b-transparent tw-border-r-[#3B4143]',
        ];
      }

      if (this.placement === 'left') {
        return [
          base,
          'tw-right-[-8px] tw-top-1/2 -tw-translate-y-1/2',
          'tw-border-t-[8px] tw-border-b-[8px] tw-border-l-[8px]',
          'tw-border-t-transparent tw-border-b-transparent tw-border-l-[#3B4143]',
        ];
      }

      if (this.placement === 'bottom') {
        return [
          base,
          'tw-top-[-8px] tw-left-1/2 -tw-translate-x-1/2',
          'tw-border-l-[8px] tw-border-r-[8px] tw-border-b-[8px]',
          'tw-border-l-transparent tw-border-r-transparent tw-border-b-[#3B4143]',
        ];
      }

      if (this.placement === 'custom') {
        return [
          base,
          'tw-top-[-7.2px] -tw-translate-x-1/2 tw-border-l-[8px] tw-border-r-[8px] tw-border-b-[8px] tw-border-l-transparent tw-border-r-transparent tw-border-b-[#3B4143]',
          this.customArrowClasses,
        ];
      }

      // Compliments the default top wrapper position
      // with down arrow direction
      return [
        base,
        'tw-bottom-[-8px] tw-left-1/2 -tw-translate-x-1/2',
        'tw-border-l-[8px] tw-border-r-[8px] tw-border-t-[8px]',
        'tw-border-l-transparent tw-border-r-transparent tw-border-t-[#3B4143]',
      ];
    },
  },
};
</script>
